import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const WelcomeModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [closing, setClosing] = useState(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setClosing(false);
    }, 350);
  };

  if (!isModalOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 z-[99999] flex items-center justify-center ${closing ? 'animate-fade-out' : ''}`}
      aria-modal="true"
      role="dialog"
      tabIndex={-1}
    >
      {/* Blurred/dimmed background */}
      <div className="fixed inset-0 bg-gradient-to-br from-gray-900/40 via-gray-800/30 to-gray-900/40 backdrop-blur-lg" />
      
      {/* Modal */}
      <div
        className="relative z-10 max-w-xl w-full mx-4 rounded-3xl p-12 flex flex-col items-center text-center border border-gray-200 shadow-2xl"
        style={{
          background: 'rgba(255,255,255,0.82)',
          boxShadow: '0 8px 40px 0 rgba(0,0,0,0.18), 0 1.5px 8px 0 rgba(0,0,0,0.04) inset',
          backdropFilter: 'blur(18px) saturate(160%)',
          WebkitBackdropFilter: 'blur(18px) saturate(160%)',
          border: '1.5px solid rgba(220,220,220,0.45)',
        }}
      >
        <h2 className="text-4xl font-black mb-6 tracking-tight text-gray-900">Hey there,</h2>
        <p className="text-lg text-gray-600 mb-8 font-medium leading-relaxed">
          iconvertify is still being polished and improved. You can use all features, but you might notice a few things taken offline or changing as we finish up.<br />
          <span className="text-emerald-600 font-semibold block mt-4">Thanks for your patience and for helping us make this the best conversion tool on the web!</span>
        </p>
        <div className="flex gap-4 w-full justify-center mt-2">
          <button
            onClick={handleClose}
            className="flex-1 px-6 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold shadow transition-all duration-200 text-base flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-offset-2 hover:scale-105 active:scale-95"
          >
            'kay <img src="/assets/skype-rolling-eyes.gif" alt="Skype rolling eyes emoji" className="w-7 h-7 ml-1 inline-block align-middle" />
          </button>
          <button
            onClick={handleClose}
            className="flex-1 px-6 py-2 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-semibold shadow transition-all duration-200 text-base focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 hover:scale-105 active:scale-95"
          >
            I understand
          </button>
        </div>
      </div>
      
      <style>{`
        .animate-fade-out {
          animation: fadeOutModal 0.35s cubic-bezier(0.4,0,0.2,1) forwards;
        }
        @keyframes fadeOutModal {
          from { opacity: 1; transform: scale(1); }
          to { opacity: 0; transform: scale(0.98); }
        }
      `}</style>
    </div>,
    document.body
  );
};

export default WelcomeModal; 